export const debitNoteConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getDebitNoteList_request: "getDebitNoteList_request",
        getDebitNoteList_success: "getDebitNoteList_success",
        getDebitNoteList_failure: "getDebitNoteList_failure",

        getAllDebitNoteList_request: "getAllDebitNoteList_request",
        getAllDebitNoteList_success: "getAllDebitNoteList_success",
        getAllDebitNoteList_failure: "getAllDebitNoteList_failure",

        postDebitNote_request: "postDebitNote_request",
        postDebitNote_success: "postDebitNote_success",
        postDebitNote_failure: "postDebitNote_failure",

        knockOffCredit_request: "knockOffCredit_request",
        knockOffCredit_success: "knockOffCredit_success",
        knockOffCredit_failure: "knockOffCredit_failure",

        deleteDebitNote_request: "deleteDebitNote_request",
        deleteDebitNote_success: "deleteDebitNote_success",
        deleteDebitNote_failure: "deleteDebitNote_failure",
    }

    let obj_formatted = {};
    let domain = "billingPortal.debitNote/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}